import { AxiosResponse, createBaseAxiosInstance, RequestConfig } from "@xmiles/holopix-helper";
import { API_DOMAIN } from '@xmiles/holopix-config';

// @ts-ignore
const isPino = typeof __PROJECT_NAME__ === "string" && __PROJECT_NAME__ === "pino";

const axiosInstance = createBaseAxiosInstance({
  baseURL: isPino ? API_DOMAIN : 'https://holopix.cn',
  timeout: 60 * 10 * 1000 * 3 // 3分钟
});

axiosInstance.interceptors.response.use(
  (response) => {
    const { success, code, msg, data } = response.data;

    if (!!success) {
      return data;
    } else {
      return Promise.reject({
        code,
        message: msg || "请求失败"
      });
    }
  },
  (error) => {
    const requestId = error.config?.params?.requestId;
    const errorMsg = error.response?.data?.msg || "服务器错误";
    console.error(`[Request ID: ${requestId}] Error: ${errorMsg}`);

    return Promise.reject({
      code: error.response?.status || 500,
      message: errorMsg
    });
  }
);

export const request = <T = any>(config: RequestConfig): Promise<AxiosResponse<T>> => {
  return axiosInstance(config);
};
